type JwtPayload = {
  user_id?: unknown;
  exp?: unknown;
  [key: string]: unknown;
};

function decodeBase64Url(value: string): string {
  const padded = value.replace(/-/g, '+').replace(/_/g, '/');
  const withPad = padded.padEnd(Math.ceil(padded.length / 4) * 4, '=');
  if (typeof atob === 'function') {
    return atob(withPad);
  }
  return Buffer.from(withPad, 'base64').toString('utf8');
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(parts[1])) as JwtPayload;
  } catch {
    return null;
  }
}

/** Qualidoc access/refresh JWTs carry numeric `user_id`. Google tokens do not. */
export function isQualidocJwt(token: string | null | undefined): boolean {
  if (!token) {
    return false;
  }
  const payload = decodeJwtPayload(token);
  return typeof payload?.user_id === 'number';
}

export function expiryFromJwt(token: string): Date | undefined {
  const payload = decodeJwtPayload(token);
  if (typeof payload?.exp !== 'number') {
    return undefined;
  }
  return new Date(payload.exp * 1000);
}
